import React from 'react';
import { trackAction } from '../utils/tracking';
import './Results.css';

const shareOnWhatsApp = (result, familyMembers = []) => {
  // Get voter names for tracking
  const voterNameEng = [result.vFirstNameEng, result.vMiddleNameEng, result.vSurnameEng]
    .filter(Boolean)
    .join(' ');
  const voterNameMar = [result.vFirstName, result.vMiddleName, result.vSurname]
    .filter(Boolean)
    .join(' ');
  
  // Track WhatsApp share action with detailed voter information
  const shareDetails = {
    hasFamilyMembers: familyMembers.length > 0,
    familyMemberCount: familyMembers.length,
    voterName: voterNameEng || voterNameMar,
    voterNameMarathi: voterNameMar || null,
    voterNameEnglish: voterNameEng || null,
    epicId: result.vEPIC || null,
    age: result.vAge || null,
    partNo: result.vPartNo || null,
    voterNo: result.voterNo || null,
    boothAddress: result.vBoothAddress || null,
    timestamp: new Date().toISOString()
  };
  
  trackAction('/', 'whatsapp_share', shareDetails);
  
  // Prompt for mobile number
  const mobileNumber = prompt('मोबाइल नंबर प्रविष्ट करा (वैकल्पिक):\nEnter mobile number (optional):');
  
  const voterName = voterNameEng;
  const voterNameMarathi = voterNameMar;
  
  // Start directly with voter information
  let shareText = `*मतदार माहिती:*

*नाव:* ${voterNameMarathi || voterName}
${voterNameMarathi && voterName ? ` (${voterName})` : ''}
${result.vAge ? `\n*वय:* ${result.vAge}` : ''}
${result.vEPIC ? `\n*EPIC ID:* ${result.vEPIC}` : ''}
${result.vPartNo ? `\n*भाग क्रमांक:* ${result.vPartNo}` : ''}
${result.voterNo ? `\n*क्रमांक:* ${result.voterNo}` : ''}
${result.vBoothAddress ? `\n*मतदान केंद्र:*\n${result.vBoothAddress}` : ''}`;

  // Add family members if available
  if (familyMembers && familyMembers.length > 0) {
    shareText += `\n\n━━━━━━━━━━━━━━━━━━━━\n\n*कुटुंब सदस्य (${familyMembers.length}):*\n\n`;
    
    familyMembers.forEach((member, idx) => {
      const memberNameMarathi = [member.vFirstName, member.vMiddleName, member.vSurname]
        .filter(Boolean)
        .join(' ');
      const memberNameEng = [member.vFirstNameEng, member.vMiddleNameEng, member.vSurnameEng]
        .filter(Boolean)
        .join(' ');
      
      shareText += `${idx + 1}. *${memberNameMarathi || memberNameEng}*`;
      if (memberNameMarathi && memberNameEng) {
        shareText += ` (${memberNameEng})`;
      }
      shareText += '\n';
      if (member.vAge) shareText += `   वय: ${member.vAge}\n`;
      if (member.vEPIC) shareText += `   EPIC ID: ${member.vEPIC}\n`;
      if (member.vPartNo) shareText += `   भाग क्रमांक: ${member.vPartNo}\n`;
      if (member.voterNo) shareText += `   क्रमांक: ${member.voterNo}\n`;
      if (member.vBoothAddress) shareText += `   मतदान केंद्र: ${member.vBoothAddress}\n`;
      shareText += '\n';
    });
  }

  shareText += `\n━━━━━━━━━━━━━━━━━━━━\n\n#वागसकर #महाराष्ट्रनवनिर्माणसेना #पुणेनिवडणूक`;

  // Encode the text properly for WhatsApp with UTF-8 support
  const siteUrl = `${window.location.origin}${window.location.pathname}`;
  
  // Encode text and URL separately to preserve emojis
  const encodedText = encodeURIComponent(shareText);
  const encodedUrl = encodeURIComponent(siteUrl);
  
  // Build WhatsApp URL
  let whatsappUrl;
  
  if (mobileNumber && mobileNumber.trim()) {
    // Clean the mobile number (remove spaces, dashes, +, etc.)
    const cleanNumber = mobileNumber.trim().replace(/[\s\-+()]/g, '');
    
    // If number doesn't start with country code, assume it's Indian (+91)
    let phoneNumber = cleanNumber;
    if (!cleanNumber.startsWith('91') && cleanNumber.length === 10) {
      phoneNumber = '91' + cleanNumber;
    } else if (cleanNumber.startsWith('0')) {
      phoneNumber = '91' + cleanNumber.substring(1);
    }
    
    // Use WhatsApp API with phone number
    whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedText}%0A%0A${encodedUrl}`;
  } else {
    // No number provided, use current behavior (open WhatsApp chat selection)
    whatsappUrl = `https://wa.me/?text=${encodedText}%0A%0A${encodedUrl}`;
  }
  
  window.open(whatsappUrl, '_blank');
};

const Results = ({ results, loading, hasSearched, onFamilySearch, familyMembers, loadingFamily }) => {
  if (loading) {
    return (
      <div className="results-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>शोधत आहे...</p>
        </div>
      </div>
    );
  }

  if (!hasSearched) {
    return null;
  }

  if (results.length === 0) {
    return (
      <div className="results-container">
        <div className="no-results">
          <p>कोणतेही निकाल सापडले नाहीत</p>
        </div>
      </div>
    );
  }

  return (
    <div className="results-container">
      <div className="results-header">
        <h2>निकाल</h2>
        <p className="results-count">{results.length} निकाल सापडले</p>
      </div>
      
      <div className="results-list">
        {results.map((result, index) => (
          <div key={index} className="result-card">
            <div className="result-name">
              <h3>
                {[result.vFirstNameEng, result.vMiddleNameEng, result.vSurnameEng]
                  .filter(Boolean)
                  .join(' ')}
              </h3>
              {result.vFirstName && (
                <p className="result-name-marathi">
                  {[result.vFirstName, result.vMiddleName, result.vSurname]
                    .filter(Boolean)
                    .join(' ')}
                </p>
              )}
            </div>
            
            <div className="result-details">
              {result.vAge && (
                <div className="detail-item">
                  <strong>वय / Age:</strong>
                  <span>{result.vAge}</span>
                </div>
              )}
              
              {result.vEPIC && (
                <div className="detail-item">
                  <strong>EPIC ID:</strong>
                  <span>{result.vEPIC}</span>
                </div>
              )}
              
              {result.vPartNo && (
                <div className="detail-item">
                  <strong>भाग क्रमांक / Part No:</strong>
                  <span>{result.vPartNo}</span>
                </div>
              )}
              
              {result.voterNo && (
                <div className="detail-item">
                  <strong>क्रमांक / Sr No:</strong>
                  <span>{result.voterNo}</span>
                </div>
              )}
              
              {result.vBoothAddress && (
                <div className="result-address">
                  <strong>मतदान केंद्र / Booth Address:</strong>
                  <p>{result.vBoothAddress}</p>
                </div>
              )}
              
              {result.new_family_id && result.new_family_id !== '1' && result.new_family_id !== '2' && (
                <div className="family-section">
                  <button
                    className="family-btn"
                    onClick={() => onFamilySearch && onFamilySearch(result.new_family_id)}
                    disabled={loadingFamily[result.new_family_id]}
                  >
                    {loadingFamily[result.new_family_id] 
                      ? 'लोड होत आहे...' 
                      : 'कुटुंब सदस्य शोधा / Find Family Members'}
                  </button>
                  
                  {familyMembers[result.new_family_id] && familyMembers[result.new_family_id].length > 0 && (
                    <div className="family-members">
                      <strong>कुटुंब सदस्य ({familyMembers[result.new_family_id].length}):</strong>
                      {familyMembers[result.new_family_id].map((member, idx) => (
                        <div key={idx} className="family-member-card">
                          <div className="family-member-name">
                            <h4>
                              {[member.vFirstName, member.vMiddleName, member.vSurname]
                                .filter(Boolean)
                                .join(' ')}
                            </h4>
                            {member.vFirstNameEng && (
                              <p className="family-member-name-eng">
                                {[member.vFirstNameEng, member.vMiddleNameEng, member.vSurnameEng]
                                  .filter(Boolean)
                                  .join(' ')}
                              </p>
                            )}
                          </div>
                          
                          <div className="family-member-details">
                            {member.vAge && (
                              <div className="detail-item">
                                <strong>वय / Age:</strong>
                                <span>{member.vAge}</span>
                              </div>
                            )}
                            
                            {member.vEPIC && (
                              <div className="detail-item">
                                <strong>EPIC ID:</strong>
                                <span>{member.vEPIC}</span>
                              </div>
                            )}
                            
                            {member.vPartNo && (
                              <div className="detail-item">
                                <strong>भाग क्रमांक / Part No:</strong>
                                <span>{member.vPartNo}</span>
                              </div>
                            )}
                            
                            {member.voterNo && (
                              <div className="detail-item">
                                <strong>क्रमांक / Sr No:</strong>
                                <span>{member.voterNo}</span>
                              </div>
                            )}
                            
                            {member.vBoothAddress && (
                              <div className="detail-item">
                                <strong>मतदान केंद्र / Booth Address:</strong>
                                <span>{member.vBoothAddress}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
            
            <div className="result-actions">
              <button 
                className="whatsapp-share-btn"
                onClick={() => {
                  const familyData = familyMembers[result.new_family_id] || [];
                  shareOnWhatsApp(result, familyData);
                }}
                title="WhatsApp वर शेअर करा"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                WhatsApp वर शेअर करा
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Results;
